// extracted by mini-css-extract-plugin
module.exports = {"container":"_2Y27L","empty":"_3pHdL","highQualityFrame":"_2nOlu","lowQualityFrame":"_2jc-X","thumbText":"_1ou7p"};